import { FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ValidatorPatterns } from '@shared/validatorpatterns';

/** Angular's minLength leaves an empty list alone (it takes an empty value to be an optional one), so it cannot say that a list must not be empty. */
const atLeastOne: ValidatorFn = (control) => ((control.value?.length ?? 0) < 1 ? { minlength: { requiredLength: 1, actualLength: control.value?.length ?? 0 } } : null);

/** JavaScript's \s counts U+FEFF as white space and .NET's does not, so the pattern alone lets a plan through that the backend refuses. U+FEFF is in none of the allowed characters either, so it is refused wherever it stands. Built from its code point: a formatter turns the escape into the bare, invisible character. */
const noByteOrderMark: ValidatorFn = Validators.pattern(new RegExp(`^[^${String.fromCodePoint(65_279)}]*$`));

/** Shared by the configuration dialogs and file transfer so the same field accepts the same values. */
export const productionPlanValidators = {
	alias: Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern(ValidatorPatterns.Alias), noByteOrderMark])!,
	// The backend refuses an empty description and one over 255 characters, so the form and the file must not let one through.
	description: Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern(ValidatorPatterns.Description), noByteOrderMark])!,
	orderPositionSql: Validators.maxLength(20000),
	title: Validators.compose([Validators.required, Validators.maxLength(255)])!,
	source: Validators.compose([Validators.required, Validators.maxLength(255)])!,
	format: Validators.maxLength(255),
	// The backend needs at least one info column and at least one status column.
	infoColumns: atLeastOne,
	statusColumns: atLeastOne,
} satisfies Record<string, ValidatorFn>;

export function validateProductionPlanField(field: keyof typeof productionPlanValidators, value: unknown): ValidationErrors | null {
	return new FormControl(value, productionPlanValidators[field]).errors;
}
